import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../services/apis";

function* handleFetchOrderCount({ payload }) {
  const { filtersString, onSuccess, onFailure } = payload;
  const filters = filtersString ? JSON.parse(filtersString) : {};
  try {
    const res = yield call(API.fetchOrderCount, filters);
    yield put(actions.fetchOrderCountSuccess(res?.data?.data));
    if (onSuccess) onSuccess(res?.data?.data);
  } catch (err) {
    const message =
      err?.response?.data?.message || err?.message || "Something went wrong";
    yield put(actions.fetchOrderCountFailure(message));
    if (onFailure) onFailure(message);
  }
}

export function* orderCountSaga() {
  yield takeLatest(actions.fetchOrderCount.type, handleFetchOrderCount);
}
